import { render } from "./answerPage.vue?vue&type=template&id=1a354bb5&scoped=true"
import script from "./answerPage.vue?vue&type=script&lang=js"
export * from "./answerPage.vue?vue&type=script&lang=js"

import "./answerPage.vue?vue&type=style&index=0&id=1a354bb5&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a354bb5"]])

export default __exports__